// extracted by mini-css-extract-plugin
export default {"avatarImg":"CurrentUser_avatarImg__SJug8"};